'use strict'

export default class DynamicMenu {
  wire () {
    const menu = $('#dynamic-menu')
    const that = this
    if (menu.length) {
      $(window).on('scroll', function () {
        that.computeMenuDisplay()
        that.computeActiveItem()
      })
    }
    return this
  }

  load () {
    const that = this
    const menu = $('#dynamic-menu')
    if (menu.length) {
      const menuList = $('<ul></ul>')
      menu.append(menuList)
      $('.menu-anchor').each((_, item) => {
        // Build menu item
        const title = $(item).attr('data-menu-title') !== '' ? $(item).attr('data-menu-title') : $(item).html()
        const navLink = $('<li class="text-base md:text-lg lg:text-lg xl:text-xl my-0 mr-3 lg:mr-20 md:mr-7"><a class="inline-block py-4" href="#">' + title + '</a></li>')
        navLink.on('click', function () {
          $('html,body').animate({ scrollTop: $(item).offset().top - menu.innerHeight() - 10 }, 'slow')
        })
        // Set an unique id
        const itemId = this.uuidv4()
        $(item).attr('data-id', itemId)
        navLink.attr('data-id', itemId)
        // Append to menu
        menuList.append(navLink)
      })
      that.computeMenuDisplay()
    }
  }

  computeMenuDisplay () {
    const scrollPos = window.pageYOffset
    const menu = $('#dynamic-menu')
    if (scrollPos > $('.menu-anchor').offset().top - menu.innerHeight() - 20) {
      menu.removeClass('hidden')
    } else {
      menu.addClass('hidden')
    }
  }

  computeActiveItem () {
    const scrollPos = window.pageYOffset
    const menu = $('#dynamic-menu')
    let lastScrolled = null
    $('.menu-anchor').each((_, item) => {
      if (scrollPos > $(item).offset().top - menu.innerHeight() - 20) {
        lastScrolled = item
      }
    })
    $('#dynamic-menu li').removeClass('active')
    $('#dynamic-menu li[data-id=' + $(lastScrolled).attr('data-id') + ']').addClass('active')
  }

  uuidv4 () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }
}
